export default __webpack_public_path__ + "static/28ccbceac79a46eb94c61ec124e65eea.ttf";